<template>
    <div class="na-form">
        <div v-if="rssDetail" class="left">
            <DxTabPanel>
                <DxItem :title="captions.BasicData">
                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">ID:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='rssDetail.RssId' :disabled="true" />
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.NameField}}</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='rssDetail.RssName' />
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required">*</div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">URL:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='rssDetail.RssUrl' />
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required">*</div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.DeactivateField}}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='rssDetail.RssDeactivated' />
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.FehlerhaftField}}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='rssDetail.RssHasError' />
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.TimeField}}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='rssDetail.RssRunScheduled' />
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.LastTimeField}}:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='rssDetail.RssLastUpdatedDate' :readOnly="true" />
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.LastErrorOnField}}:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='rssDetail.RssErrorOn' :readOnly="true" />
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.ErrorNotifField}}:</div>
                            <div class="dx-field-value">
                                <DxTextArea :value='rssDetail.RssError' :readOnly="true" :autoResizeEnabled="true" />
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.ReportTTyField}}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox :dataSource="ttySimpleList" valueExpr="TtyId" displayExpr="TtyName" v-model:value="rssDetail.RssAutoCreateReportTopicsTtyId">
                                </DxSelectBox>
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.ReportFTField}} :</div>
                            <div class="dx-field-value">
                                <DxSelectBox :dataSource="resourceTypeList" valueExpr="RtyId" displayExpr="RtyName" v-model:value="rssDetail.RssAutoCreateReportTopicsRtyId">
                                </DxSelectBox>
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.ReportTOwnerField}}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox :dataSource="userList" valueExpr="UsrId" displayExpr="UsrFullName" v-model:value="rssDetail.RssAutoCreateReportTopicsOwnerId">
                                </DxSelectBox>
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.ChangedOnField}}:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='rssDetail.RssChangedOn' :readOnly="true" />
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.ChangedByField}}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='rssDetail.RssChangedBy' :readOnly="true" />
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.CreatedOnField}}:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='rssDetail.RssCreatedOn' :readOnly="true" />
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.CreatedByField}}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='rssDetail.RssCreatedBy' :readOnly="true" />
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>

                    </div>
                </DxItem>
                <DxItem :title="captions.FeedInfo">
                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.TitleField}}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='rssDetail.RssTitle' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.DescField}}:</div>
                            <div class="dx-field-value">
                                <DxTextArea :value='rssDetail.RssDescription' :readOnly="true" :autoResizeEnabled="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.LinkField}}:</div>
                            <div class="dx-field-value">
                                <a v-bind:href="rssDetail.RssLink" target="_blank" class="na-link">
                                    <DxTextBox :value='rssDetail.RssLink' :readOnly="true" />
                                </a>
                            </div>
                        </div>
                    </div>
                </DxItem>
                <DxItem :title="captions.Searchfields">
                    <DxDataGrid :data-source="suchfeldRssList"
                                key-expr="LitId"
                                :remote-operations="false"
                                :allow-column-reordering="true"
                                :row-alternation-enabled="true"
                                :show-borders="true"
                                @saved="onSuchfeldSaving">
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   select-text-on-edit-start="true"
                                   start-edit-action="click"
                                   mode="cell" />
                        <DxColumn data-field="Selected" :caption="captions.SelectedField" data-type="boolean" :width="120" />
                        <DxColumn data-field="LitName" :caption="captions.SearchfieldField" data-type="string" :allowEditing="false" />
                    </DxDataGrid>

                </DxItem>
            </DxTabPanel>
        </div>

        <div class="na-buttons-row">
            <div>
                <DxButton :width="120"
                          :text="btn.SaveBtn"
                          :type="saveButtonType"
                          :disabled="saveButtonDisabled"
                          styling-mode="contained"
                          @click="onSaveClick()" />
            </div>
            <div>
                <DxButton :width="120"
                          :text="btn.DeleteBtn"
                          type="danger"
                          styling-mode="contained"
                          @click="onDeleteClick()" />
            </div>

            <div>
                <DxButton :width="120"
                          :text="btn.BackBtn"
                          type="back"
                          styling-mode="contained"
                          @click="onCancelClick($event)" />
            </div>
        </div>
    </div>

</template>

<script>

    import { DxTextBox } from 'devextreme-vue/text-box'
    import { DxTextArea } from 'devextreme-vue/text-area'
    import { DxButton } from 'devextreme-vue/button'
    import { DxSelectBox } from 'devextreme-vue/select-box'
    import { DxCheckBox } from 'devextreme-vue/check-box'
    import { DxDataGrid, DxColumn, DxEditing } from 'devextreme-vue/data-grid'
    import notify from 'devextreme/ui/notify'
    import { DxDateBox } from 'devextreme-vue/date-box'
    import { DxTabPanel } from 'devextreme-vue/tab-panel';
    import { DxItem } from 'devextreme-vue/html-editor';
    import $ from 'jquery';
    import { confirm } from "devextreme/ui/dialog"

    export default {
        name: 'RssFeedDetail',
        components: {
            DxCheckBox,
            DxButton,
            DxTextBox,
            DxTabPanel,
            DxItem,
            DxTextArea,
            DxDateBox,
            DxDataGrid,
            DxColumn,
            DxEditing,
            DxSelectBox
        },
        data() {
            return {
                captions: {
                    BasicData: this.$LanguageProvider.GetResource("BasicData", "Caption", "Basisdaten"),
                    FeedInfo: this.$LanguageProvider.GetResource("FeedInfo", "Caption", "Feed-Informationen"),
                    Searchfields: this.$LanguageProvider.GetResource("Searchfields", "Caption", "Suchfelder"),
                    NameField: this.$LanguageProvider.GetResource("NameField", "Caption", "Name"),
                    DeactivateField: this.$LanguageProvider.GetResource("DeactivateField", "Caption", "Deaktiviert"),
                    FehlerhaftField: this.$LanguageProvider.GetResource("FehlerhaftField", "Caption", "Fehlerhaft"),
                    TimeField: this.$LanguageProvider.GetResource("TimeField", "Caption", "Zeitgesteuert ausführen"),
                    LastTimeField: this.$LanguageProvider.GetResource("LastTimeField", "Caption", "Zuletzt ausgeführt am"),
                    LastErrorOnField: this.$LanguageProvider.GetResource("LastErrorOnField", "Caption", "Letzter Fehler am"),
                    ErrorNotifField: this.$LanguageProvider.GetResource("ErrorNotifField", "Caption", "Fehlermeldung"),
                    ReportTTyField: this.$LanguageProvider.GetResource("ReportTTyField", "Caption", "Report Autoimport Topic Type"),
                    ReportFTField: this.$LanguageProvider.GetResource("ReportFTField", "Caption", "Report Autoimport File Type"),
                    ReportTOwnerField: this.$LanguageProvider.GetResource("ReportTOwnerField", "Caption", "Report Autoimport Topic Owner"),
                    ChangedOnField: this.$LanguageProvider.GetResource("ChangedOnField", "Caption", "Geändert am"),
                    ChangedByField: this.$LanguageProvider.GetResource("ChangedByField", "Caption", "Geändert von"),
                    CreatedOnField: this.$LanguageProvider.GetResource("CreatedOnField", "Caption", "Erstellt am"),
                    CreatedByField: this.$LanguageProvider.GetResource("CreatedOnField", "Caption", "Erstellt von"),
                    TitleField: this.$LanguageProvider.GetResource("TitleField", "Caption", "Titel"),
                    DescField: this.$LanguageProvider.GetResource("DescField", "Caption", "Beschreibung"),
                    LinkField: this.$LanguageProvider.GetResource("LinkField", "Caption", "Link"),
                    SelectedField: this.$LanguageProvider.GetResource("SelectedField", "Caption", "Ausgewählt"),
                    SearchfieldField: this.$LanguageProvider.GetResource("SearchfieldField", "Caption", "Suchfeld"),
                },
                btn: {
                    SaveBtn: this.$LanguageProvider.GetResource("SaveBtn", "Caption", "Speichern"),
                    DeleteBtn: this.$LanguageProvider.GetResource("DeleteBtn", "Caption", "Löschen"),
                    BackBtn: this.$LanguageProvider.GetResource("BackBtn", "Caption", "Zurück"),
                }
            }
        },
        computed: {
            rssDetail() {
                return this.$store.state.rssFeedStore.rssDetail
            },
            rssDetailText() {
                return JSON.stringify(this.$store.state.rssFeedStore.rssDetail)
            },
            rssFeedUpdated() {
                return this.$store.state.rssFeedStore.rssFeedUpdated
            },
            suchfeldRssList() {
                return this.$store.state.suchfeldStore.suchfeldRssList
            },
            suchfeldRssListText() {
                return JSON.stringify(this.$store.state.suchfeldStore.suchfeldRssList)
            },
            saveButtonType() {
                return this.$store.state.rssFeedStore.rssDetailChanged || this.$store.state.suchfeldStore.suchfeldRssListChanged  ? "success" : "normal"
            },
            saveButtonDisabled() {
                return this.$store.state.rssFeedStore.rssDetailChanged || this.$store.state.suchfeldStore.suchfeldRssListChanged ? false : true
            },
            ttySimpleList() {
                return this.$store.state.topicTypeStore.ttySimpleList
            },
            resourceTypeList() {
                return this.$store.state.resourceTypeStore.resourceTypeList
            },
            userList() {
                return this.$store.state.userStore.userList
            }
        },
        props: {
            rssId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        watch: {
            rssFeedUpdated: function () {
                //$("form").attr("action", window.location.pathname + "?action=return").submit()
                notify("Your data was successfully updated")
            },
            rssDetailText: function (newVal, oldVal) {
                if (oldVal != "{}")
                    this.$store.state.rssFeedStore.rssDetailChanged = true
            },
            suchfeldRssListText: function (newVal, oldVal) {
                if (oldVal != "[]")
                    this.$store.state.suchfeldStore.suchfeldRssListChanged = true
            }
        },
        mounted: function () {
            let vm = this
            this.$store.dispatch("getRssDetail", { rssId: vm.rssId })
            this.$store.dispatch("getAllSuchfeldInfosForRssFeed", { rssId: vm.rssId })
            this.$store.dispatch("getTtySimpleList")
            this.$store.dispatch("getResourceTypeList")
            this.$store.dispatch("getUserList")
        },
        methods: {
            onCancelClick() {
                $("form").attr("action", window.location.pathname + "?action=return").submit();
            },
            onSaveClick() {
                this.$store.dispatch("saveRssEntry")
                this.$store.dispatch("saveSuchfeldRssList", { rssId: this.rssId })
            },
            onDeleteClick() {
                let result = confirm("Sind Sie sicher, dass Sie den Feed löschen möchten?", "Löschen bestätigen");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        $("form").attr("action", window.location.pathname + "?action=delete&rssId=" + this.rssId).submit(); 
                    }
                });
            },
            onSuchfeldSaving() {
            }
        }
    }


</script>
<style>

    div {
        text-align: left;
    }

    .options {
        margin-top: 20px;
        padding: 20px;
        background-color: rgba(191, 191, 191, 0.15);
        box-sizing: border-box;
        width: 100%;
    }

    .na-link {
        cursor: pointer;
    }
</style>
